export default __webpack_public_path__ + "static/media/ic-display.5f62b6bb.svg";